import { Component } from 'react';
import { assetProcessed } from '../actions/preloader-actions';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';


class PreLoader extends Component {
    constructor(props) {
        super(props);
        
    }

    componentDidUpdate() {
const { assetProcessed, assetsToPreload, assetsPreloaded } = this.props;
        if(assetsToPreload.length>0 ){
           
           if( assetsPreloaded.indexOf(assetsToPreload[0])<0){
          
            const img = document.createElement('img');
            img.src = assetsToPreload[0]; // Assigning the img src immediately requests the image 
           }
           assetProcessed(assetsToPreload[0]);
        }
       

       

    }
  

    render() {
      return null;
    }
}

PreLoader.propTypes = {
    assetsToPreload:PropTypes.array,
    assetsPreloaded: PropTypes.array,
    assetProcessed: PropTypes.func

};

const mapStateToProps = state => {
    return {
        assetsToPreload: state.preloader.assetsToPreload,
        assetsPreloaded: state.preloader.assetsPreloaded
    };
};

const mapDispatchToProps = dispatch => {
    return {
          assetProcessed: (asset) => dispatch(assetProcessed(asset)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreLoader);



// WEBPACK FOOTER //
// ./src/preloader/components/preloader.jsx